import { render, staticRenderFns } from "./ThgBillingCreditorSelectionView.vue?vue&type=template&id=48a0bca8&"
import script from "./ThgBillingCreditorSelectionView.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingCreditorSelectionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports